module.exports = __webpack_public_path__ + "img/mrxweb.8d4fc956.svg";